export default "__VITE_ASSET__BK8wzrgS__"